import { create } from "zustand";

const store = create((set) => ({
  user: null,
  setUser: (user) => set(() => ({ user })),

  organization: JSON.parse(localStorage.getItem("jobego-organization")) || null,
  setOrganization: (organization) => {
    localStorage.setItem("jobego-organization", JSON.stringify(organization));
    set(() => ({ organization }));
  },

  impersonation: null,
  setImpersonation: (impersonation) => set(() => ({ impersonation })),

  // Entity store for breadcrumbs — pages register their entity on mount
  entities: {},
  setEntity: (type, data) => set((state) => ({ entities: { ...state.entities, [type]: data } })),
  clearEntity: (type) =>
    set((state) => {
      const { [type]: _, ...rest } = state.entities;
      return { entities: rest };
    }),
}));

export default store;
